"use client";

import { useLocale, useTranslations } from "next-intl";
import { FaLocationDot } from "react-icons/fa6";
import { MdMarkEmailUnread, MdOutlinePhoneInTalk } from "react-icons/md";
import { motion } from "framer-motion";
import ContactForm from "./ContactForm";

const contactInfo = [
  {
    id: 1,
    icon: FaLocationDot,
    name_en: "Location",
    name_ar: "الموقع",
    value: "Makkah, Saudi Arabia",
    valueAr: "مكة المكرمة، المملكة العربية السعودية",
  },
  {
    id: 2,
    icon: MdMarkEmailUnread,
    name_en: "E-Mail",
    name_ar: "البريد الإلكتروني",
    value: "info@sna-alaqaria.com",
  },
  {
    id: 3,
    icon: MdOutlinePhoneInTalk,
    name_en: "Phone Number",
    name_ar: "رقم الجوال",
    value: "+966 5306 62244",
  },
];

export default function ContactInfo() {
  const t = useTranslations("Contact");
  const locale = useLocale();

  return (
    <section>
      <div>
        <h2 className="text-4xl text-center text-main font-bold">
          {t("contactUs")}
        </h2>
        <p className="text-center mt-4 max-w-4xl xm:text-lg leading-7 mx-auto text-dark/80">
          {t("contactDes")}
        </p>
      </div>

      <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 gap-8 gap-y-14 justify-center mt-32 pb-8">
        {contactInfo.map((info, idx) => (
          <div
            key={info.id}
            className={`${idx === 2 && "xs:col-span-2 sm:col-span-1"} `}
          >
            <div className="flex flex-col gap-3 items-center">
              <div className="text-4xl bg-main text-white p-4 rounded-full">
                <motion.span
                  initial={{ opacity: 0, y: -20, rotate: -10 }}
                  whileInView={{ opacity: 1, y: 0, rotate: 0 }}
                  transition={{ duration: 0.5, delay: idx * 0.2 }}
                  viewport={{ once: true }}
                >
                  <info.icon className="w-8 h-8" />
                </motion.span>
              </div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: idx * 0.3 }}
                viewport={{ once: true }}
                className="flex flex-col gap-4 items-center"
              >
                <h4 className="text-xl font-semibold text-main">
                  {locale === "ar" ? info.name_ar : info.name_en}
                </h4>
                <p
                  style={{
                    unicodeBidi: "plaintext",
                  }}
                  className="text-dark text-center"
                >
                  {locale === "ar" && info.valueAr ? info.valueAr : info.value}
                </p>
              </motion.div>
            </div>
          </div>
        ))}
      </div>

      <ContactForm />
    </section>
  );
}
